
import { defineComponent } from 'vue'
import heic2any from 'heic2any'

export default defineComponent({
  name: 'PreviewImage',
  props: {
    imgUrl: {
      type: String,
      required: true,
    },
    toolBar: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      previewUrl: null as string | null,
    }
  },
  watch: {
    imgUrl: {
      immediate: true,
      async handler(newUrl) {
        if (newUrl && (newUrl.includes('.heic') || newUrl.includes('.heif'))) {
          this.previewUrl = await this.convertHeicHeifUrlToImgUrl(newUrl)
        } else {
          this.previewUrl = newUrl
        }
      },
    },
  },
  methods: {
    async convertHeicHeifToUrl(file: File) {
      try {
        const convertedBlob = await heic2any({
          blob: file,
          toType: 'image/jpeg',
          quality: 0.3,
        })
        return URL.createObjectURL(convertedBlob as Blob)
      } catch (error) {
        console.error('Error converting .heic and .heif to URL:', error)
        throw error
      }
    },
    async convertHeicHeifUrlToImgUrl(HeicHeifUrl: string) {
      try {
        const response = await fetch(HeicHeifUrl)
        const blob = await response.blob()
        if (HeicHeifUrl.includes('.heic')) {
          return await this.convertHeicHeifToUrl(
            new File([blob], 'image.heic', { type: 'image/heic' }),
          )
        } else {
          return await this.convertHeicHeifToUrl(
            new File([blob], 'image.heif', { type: 'image/heif' }),
          )
        }
      } catch (error) {
        console.error('Error converting .heic and .heif url to image URL:', error)
        throw error
      }
    },
  },
})
